import { useQuery } from '@tanstack/react-query';
import { IEmbedV2Response } from '@opengov/reporting-types';
import { getV2Embed } from '@opengov/reporting-embeds';

import { useToast } from '../../../../stories/components/Toast/context/useToast.context';
import { embedPickerQueryKeys, EmbedKeyParams } from './embedPickerQueryKeys';

export type UseEmbedParams = EmbedKeyParams | null;

// Fetches a single embed by ID via the v2 endpoint. Pass null to disable.
export function useEmbed(params: UseEmbedParams) {
  const { toggleToast } = useToast();

  return useQuery<IEmbedV2Response, Error>({
    queryKey: params
      ? embedPickerQueryKeys.embed(params)
      : ([...embedPickerQueryKeys.all, 'embed', 'disabled'] as const),
    queryFn: async () => {
      if (!params) throw new Error('Disabled');
      return getV2Embed(params.embedId);
    },
    enabled: params !== null,
    onError: () => {
      toggleToast({ title: 'Could not load embed', severity: 'error' });
    }
  });
}
